import { render, staticRenderFns } from "./DirectCandidateWalletTransactionView.vue?vue&type=template&id=70b7bf7e"
import script from "./DirectCandidateWalletTransactionView.vue?vue&type=script&lang=js"
export * from "./DirectCandidateWalletTransactionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports